export class ArrayUtil {
  static clone(array, className?) {
    let list = (array || []).map((item) => {
      return className ?  new className(item) : JSON.parse(JSON.stringify(item));
    })
    return list;
  }
}
